import DocumentDetailListView from "@/components/documents/DocumentDetailListView.vue";
import ConfirmDlg from "@/components/ConfirmDialog.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import CreateDirectory from "@/components/documents/CreateDirectory.vue";
import { fileIcons, MAX_UPLOAD_SIZE } from "../../utils/constant";
import UploadFile from "@/components/documents/UploadFile.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { createUUID, formatBytes } from "../../utils/util";
import SearchInput from "@/components/SearchInput.vue";
import ATreeview from "@/components/ATreeView.vue";
import ABreadcrumbs from "@/wrapper-component/ABreadcrumbs.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import { isObject } from "lodash";
import ChunkFileUpload from "../../mixin/ChunkFileUpload";
import DocumentMixin from "@/components/documents/DocumentMixin";

export default {
  name: "DocumentExplorer",
  mixins: [SignalRMixin, ChunkFileUpload, DocumentMixin],
  data() {
    return {
      defaultSortOrder: null,
      chunkUploadFilesList: [],
      isChunkUpload: false,
      render: 0,
      loadingFiles: false,
      loadingDirectories: false,
      hideDetails: false,
      isFileRequired: false,
      folder_names: [],
      parentNode: {},
      selectedDirectoryData: {},
      selectedFolderData: {},
      screenHeight: 0,
      x: 0,
      y: 0,
      rightClickItem: null,
      documentFound: false,
      fileIcons,
      uploadingFiles: [],
      createFolderDialog: false,
      createRootDialog: false,
      valid: false,
      uploadDialog: false,
      loadingUpload: false,
      newFolder: "",
      dataloading: false,
      dropFileSuccessDialog: false,
      page: 1,
      pageCount: 0,
      selectedFiles: [],
      selectionClear: false,
      displayMessage: false,
      message: "",
      messageType: "",
      search: "",
      calmenu: false,
      calmenu2: false,
      requiredRules: [(v) => this.valid || "Enter valid due date."],
      selectedView: "Details",
      selectedViewIcon: "mdi-format-list-bulleted",
      newFile: "",
      initiallyOpen: ["Files"],
      files: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-code-json",
        md: "mdi-language-markdown",
        pdf: "mdi-file-pdf-box",
        png: "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
      },
      tree: [],
      result: [],
      rules: [
        // (v) =>
        //     (v && v.length > 0) ||
        //     (this.uploadingFiles && this.uploadingFiles.length > 0) || this.$t("documents.uploadedValidationMessage"),
        (v) =>
          !v ||
          !v.some((file) => file.size > 2000000) ||
          "File size should be less than 2 MB!",
      ],
      fileLoaded: false,
      uploadDisabled: false,
      lvalue: 0,
      selectedNodeId: "",
      selectedNode: null,
      selectedItems: [],
      showMenu: false,
      menuItems: ["create file", "create directory"],
      file_accept: [
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/bmp",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-fontobject",
        "application/vnd.ms-fontobject",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/plain",
        "application/zip",
        "application/x-zip",
        "application/octet-stream",
        "application/x-zip-compressed",
        "application/vnd.rar",
        "application/x-rar-compressed",
        "multipart/x-zip",
        "application/gzip",
        "image/svg+xml",
        "application/vnd.ms-excel.sheet.macroEnabled.12"
      ],
      documentdropFiles: {},
    };
  },
  components: {
    DocumentDetailListView,
    MessageSheet,
    ConfirmDlg,
    CreateDirectory,
    UploadFile,
    SearchInput,
    ATreeview,
    ABreadcrumbs,
  },
  async mounted() {
    this.loadingFiles = true;
    if (this.$security.checkUserAccess("ViewDirectory")) {
      this.loadingDirectories = true;
      await this.getDirectoryListApi();
      this.loadingDirectories = false;
    }
    await this.setTreeViewFocus();
    await this.signalRInit(`directory_${this.selectedTenant}`);
    this.initializeSortDataAndSignalR("a8f7d078-5bf1-4365-9d53-35070229bc64");
    // Commented code addresses issue #1720.
    // await this.signalRDocumentInit(`document_${this.selectedTenant}`);
    this.loadingFiles = false;
  },
  watch: {
    uploadingFiles: {
      immediate: true,
      async handler() {
        if (this.uploadingFiles.length == 0) {
          this.valid = false;
        } else {
          this.isFileRequired = false;
          this.valid = true;
        }
      },
    },
    directoryList: {
      immediate: true,
      async handler() {
        if (this.selectedNode) {
          await this.selectItem(this.selectedNode);
        }
      },
    },
    isFileRequired(value) {
      this.hideDetails = value;
    },
  },
  computed: {
    ...mapState({
      directoryList: (state) => state.directory.directoryList,
    }),
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
    }),
    uploadLoaderText() {
      return this.$t("documents.progressUploading");
    },
    errorCount() {
      let count = 0;
      for (const item of this.uploadingFiles) {
        if (this.checkStatus(item).status === false) {
          count++;
        }
      }
      return count;
    },
    loaderText() {
      return this.$t("LoaderText");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    treeItems() {
      return this.filterRootItems(this.directoryList);
    },
    directory_names() {
      const names = [];
      this.directoryList.forEach((directory) => {
        if (directory.parentId == null || directory.parentId == "") {
          names.push(directory.name);
        }
      });
      return names;
    },
    fileList() {
      return this.selectedItems;
    },

    views() {
      return [
        {
          text: this.$t("largeIcons"),
          iconSrc: "mdi-view-grid",
          id: "gridView",
        },
        {
          text: this.$t("details"),
          iconSrc: "mdi-format-list-bulleted",
          id: "listView",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      createDocuments: "document/createDocuments",
      getDirectory: "directory/getDirectory",
      deleteDirectory: "directory/deleteDirectory",
      deleteDirectories: "directory/deleteDirectories",
      deleteDocuments: "document/deleteDocuments",
      downloadDocumentAPI: "document/downloadDocument",
      getDirectoryListApi: "directory/getDirectoryList",
    }),
    getWidth(id) {
      let item = document.getElementById(id);
      if (item) {
        return `${item.offsetWidth - 28}px`;
      }
    },
    expandNode(data) {
      if (data.length) {
        this.render++;
      }
    },
    afterResizingSplitter() {
      this.render++;
    },
    addFolder() {
      if (this.selectedItems.length) {
        this.folder_names = [];
        this.selectedItems.filter((item) => {
          if (item.name) {
            this.folder_names.push(item.name);
          }
        });
      }
      this.createFolderDialog = true;
    },
    async renameDirectory(item) {
      await this.selectItem(item);
      if (this.selectedNode.parentId) {
        this.parentNode = await this.getDirectory(this.selectedNode.parentId);
        this.folder_names = [];
        this.parentNode.directories.filter((item) => {
          this.folder_names.push(item.name);
        });
        this.selectedFolderData = this.selectedNode;
        this.createFolderDialog = true;
      } else {
        this.selectedDirectoryData = this.selectedNode;
        this.createRootDialog = true;
      }
    },
    onResize() {
      this.screenHeight = window.innerHeight - 195;
    },
    showMenuOnClick(e, item) {
      e.preventDefault();
        this.rightClickItem = item;
        this.showMenu = false;
        this.x = e.clientX;
        this.y = e.clientY;
        this.$nextTick(() => {
          this.showMenu = true;
        });
    },
    checkStatus(file) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      let filesWithStatus = {
        filename: file.fileName,
      };
      if (!this.file_accept.includes(file.type)) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileErrorMsg", {
          filename: file.fileName,
        });
      } else if (file.size > maxSize) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(maxSize),
        });
      } else {
        filesWithStatus.status = true;
        filesWithStatus.message = "Success";
      }
      return filesWithStatus;
    },

    async setTreeViewFocus() {
      if (this.treeItems.length > 0) {
        await this.selectItem(this.treeItems[0]);
      } else {
        this.selectedItems = [];
        this.selectionClear = !this.selectionClear;
        this.result = [];
      }
    },
    async createFolder() {
      if (this.rightClickItem) {
        await this.selectItem(this.rightClickItem);
        if (this.selectedItems.length) {
          this.folder_names = [];
          this.selectedItems.filter((item) => {
            if (item.name) {
              this.folder_names.push(item.name);
            }
          });
        }
        this.createFolderDialog = true;
      }
    },

    async setTreeViewFocusOnDeletion(id) {
      let nodes = this.treeItems.filter((f) => f.id !== id && !f.parentId);
      if (nodes.length > 0) {
        await this.selectItem(nodes[0]);
      } else {
        this.selectedItems = [];
        this.selectionClear = !this.selectionClear;
        this.result = [];
      }
    },
    async confirmDelete() {
      try {
        if (!this.rightClickItem) return;

        const item = this.rightClickItem;
        await this.selectItem(item);

        const dirName =
          item.type == "group"
            ? this.$t("documents.hRootDirectory")
            : this.$t("documents.hFolder");
        const folName =
          item.type == "group"
            ? this.$t("documents.lblRootDirectory")
            : this.$t("documents.lblFolder");

        if (
          await this.$refs.confirm.open(
            this.$t("documents.hFolderDeletion", { directory: dirName }),
            this.$t("documents.folderDeleteConfirmationMessage", {
              directory: folName,
              folderName: item.name,
            }),
            { dialogIcon: "alert" }
          )
        ) {
          await this.deleteDirectory(item.id);
          this.showMessageSheet(
            this.$t("documents.DirectoryDeleteSuccessMessage"),
            "success"
          );
        }
      } catch (error) {
        console.log(error, "api error")
      }
    },
    async confirmDeleteMultipleFiles(items) {
      if (
        await this.$refs.confirm.open(
          this.$t("documents.hMultipleDeletion"),
          this.$t("documents.MultipleDeleteConfirmationMessage"),
          { dialogIcon: "alert" }
        )
      ) {
        try {
          await this.deleteDirectories(items);

          let isAllDirectories = items.every((d) => d.type === "directory");
          let isAllFiles = items.every((d) => d.type === "file");

          if (isAllDirectories) {
            this.showMessageSheet(
              this.$t("documents.DirectoryDeleteSuccessMessage"),
              "success"
            );
          } else if (isAllFiles) {
            this.showMessageSheet(
              this.$t("documents.DocDeleteSuccessMessage"),
              "success"
            );
          } else {
            this.showMessageSheet(
              this.$t("documents.FolderDocDeleteSuccessMessage"),
              "success"
            );
          }
        } catch (error) {
          console.log(error, "api error")
        }
      }
    },

    async deleteDocuments() {
      const promises = [];
      this.deleteDocumentIds.forEach((id) => {
        promises.push(this.deleteDocuments(id));
      });
      await Promise.all(promises);
    },

    async deepDownloadFiles(selectedFiles) {
      let directories = selectedFiles.filter((f) => f.type === "directory");
      directories.forEach(async (directory) => {
        let node = await this.getDirectory(directory.id);
          let items = await this.getSelectedItems(node);
          await this.deepDownloadFiles(items);
      });

      await this.downloadFiles(selectedFiles);
    },
    async downloadDocument() {
      this.documentFound = false;
      let directories = this.selectedFiles.filter(
        (f) => f.type === "directory"
      );
      if (directories.length > 0) {
        await this.$refs.confirm.open(
          this.$t("documents.hDirectoryDownloadNotice"),
          this.$t("documents.msgDirectoryDonwloadNotice"),
          { dialogIcon: "alert", noconfirm: true }
        );
      }
      await this.deepDownloadFiles(this.selectedFiles);
    },

    async downloadFiles(selectedFiles) {
      let files = selectedFiles.filter((f) => f.type === "file");
      files.forEach(async (file) => {
        this.documentFound = true;
        const params = {
          documentId: file.id,
          filename: file.fileName,
        };
        const res = await this.downloadDocumentAPI(params);
        let contentType = res.headers["content-type"];
        let blob = new Blob([res.data], { type: contentType });
        let url = window.URL.createObjectURL(blob);
        let docUrl = document.createElement("a");
        docUrl.href = url;
        docUrl.setAttribute("download", file.fileName);
        document.body.appendChild(docUrl);
        docUrl.click();
      });
    },
    addDropFile(e) {
      this.newFile = e.dataTransfer.files[0];
    },
    fileError(err) {
      this.showMessageSheet(
        err.error + " File(s) Size Limit Exceeded",
        "error"
      );
    },
    dropFileError(err) {
      this.showMessageSheet(err.error, "error");
    },

    filterRootItems(Items) {
      const result = [];
      for (const parent of Items.filter((s) => !s.parentId)) {
        result.push({
          ...parent,
          type: "group",
          children: this.getSubTreeItems(
            this.filterItemsForSubdirectories(parent.id)
          ),
        });
      }
      return result;
    },

    findDirectoryInItems(Items, id) {
      let directories = Items.filter((s) => s === id);
      return directories.length > 0;
    },
    filterItemsForSubdirectories(parentId) {
      let directories = this.directoryList.filter(
        (f) => f.parentId === parentId
      );
      return directories;
    },

    getSubTreeItems(Items) {
      const result = [];
      for (const parent of Items) {
        if (!parent.parentId) {
          continue;
        } else {
          result.push({
            ...parent,
            type: "directory",
            children: this.getSubTreeItems(
              this.filterItemsForSubdirectories(parent.id)
            ),
          });
        }
      }
      return result;
    },
    filterTreeItems(Items) {
      const result = [];
      for (const parent of Items) {
        if (parent.type === "file") {
          continue;
        } else if (parent.children) {
          result.push({
            ...parent,
            children: this.filterTreeItems(parent.children),
          });
        } else {
          result.push(parent);
        }
      }
      return result;
    },

    getChildItems(Items, id) {
      for (const parent of Items) {
        let foundNode = this.getChildNode(parent, id);
        if (foundNode) {
          return foundNode;
        }
      }
      return null;
    },

    async getSelectedItems(items) {
      let result = [];
      items.directories.forEach((directory) => {
        result.push({
          ...directory,
          type: "directory",
        });
      });

      items.documents.forEach((doc) => {
        result.push({
          ...doc,
          type: "file",
          file: doc.fileName.split(".").pop(),
        });
      });
      return result;
    },
    async selectItem(item) {
      this.selectedNode = null;
      this.selectedNode = await this.getDirectory(item.id);
      this.selectedItems = await this.getSelectedItems(this.selectedNode);
      this.selectedNodeId = item.id;
      this.selectionClear = !this.selectionClear;
      this.result = [];
      this.getSitePath(this.treeItems, item.id);
    },
    setView(view) {
      this.selectedView = view.text;
      this.selectedViewIcon = view.iconSrc;
    },
    getSitePath(nodes, id) {
      for (const parent of nodes) {
        this.getTraversePath(parent, id);
      }
    },
    getTraversePath(node, id) {
      if (this.isChildNode(node, id)) {
        this.result.push({ text: node.name, selNode: node });
        if (node.children) {
          for (const element of node.children) {
            let chnode = element;
            this.getTraversePath(chnode, id);
          }
        }
      }
    },
    isChildNode(parentnode, id) {
      if (parentnode.id == id) {
        return true;
      }
      if (parentnode.children) {
        for (const element of parentnode.children) {
          let node = element;
          if (this.isChildNode(node, id)) {
            return true;
          }
        }
      }
      // no matches found - return false
      return false;
    },

    getChildNode(parentnode, id) {
      if (parentnode.id == id) {
        return parentnode;
      }
      if (parentnode.children) {
        for (const element of parentnode.children) {
          let node = element;
          let res = this.getChildNode(node, id);
          if (res) {
            return res;
          }
        }
      }
      // no matches found - return false
      return null;
    },

    onSelection(selectedFiles) {
      this.selectedFiles = selectedFiles;
    },

    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },

    generateGuid() {
      let result, i, j;
      result = "";
      for (j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20) result = result + "-";
        i = Math.floor(Math.random() * 16)
          .toString(16)
          .toUpperCase();
        result = result + i;
      }
      return result;
    },
    addChild(item, NodeName, Nodetype) {
      const id = this.generateGuid();
      if (this.validateNewFolder(item, NodeName)) {
        let message = "Exist";
        this.showMessageSheet(message, "error");
        return;
      }
      if (!item.children) {
        this.$set(item, "children", []);
      }

      const name = NodeName;
      const type = Nodetype;
      const modified = "2021-07-18 12:40";
      item.children.push({
        name,
        type,
        id,
        modified,
      });
    },
    validateNewFolder(selectedNode, name) {
      if (selectedNode.children) {
        let newArray = selectedNode.children.filter(function (el) {
          return el.name === name;
        });
        return newArray.length > 0;
      } else {
        return false;
      }
    },
    findItem(name, items = null) {
      return items.reduce((acc, item) => {
        if (acc) {
          return acc;
        }

        if (item.name === name) {
          return item;
        }

        if (item.children) {
          return this.findItem(name, item.children);
        }

        return acc;
      }, null);
    },
    addUploadingFiles,
    removeUploadingFile,
    onDocumentUpload,
    uploadDropedFiles,
    formatBytes,
    signalRInit,
    signalRDocumentInit,
    openUploadDialog,
    onUpdateChunkUpload,
    closeUploadFiles() {
      this.uploadingFiles = [];
      this.uploadDialog = false;
      this.isFileRequired = false;
      this.isChunkUpload = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    showFileReqMsg(files) {
      return files && files.length === 0;
    },
    isFileValid(file, maxSize) {
      return this.file_accept.includes(file.type) && file.size < maxSize;
    },
    resetForm() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    getFormData(item, selectedTenant, selectedNode, isChunkUpload) {
      const formData = new FormData();
      formData.append("tenantId", selectedTenant);
      formData.append("topicId", "");
      formData.append("documentId", createUUID());
      formData.append("meetingId", "");
      formData.append("agendaId", "");
      formData.append("directoryId", selectedNode.id);
      formData.append("peopleId", "");
      formData.append("file", item);
      formData.append("chunk_upload", isChunkUpload);
      formData.append("filename", item.name);
      formData.append("content_type", item.type);
      return formData;
    },
    async uploadFiles(files, maxSize) {
      const filesWithStatus = [];

      for (const item of files) {
        if (!this.isFileValid(item, maxSize)) continue;

        const isChunkUpload = this.chunkUploadFilesList.some(
          (c) => c.fileName === item.name && c.isChunkUpload === true
        );

        const formData = this.getFormData(
          item,
          this.selectedTenant,
          this.selectedNode,
          isChunkUpload
        );

        const result = isChunkUpload
          ? await this.uploadFileInChunks(item, formData)
          : await this.createDocuments(formData);

        filesWithStatus.push(this.fileStatus(item, result));
      }

      return filesWithStatus;
    },
    fileStatus(item, result) {
      if (result === "OK") {
        return {
          filename: item.name,
          size: item.size,
          type: item.type,
          status: true,
          message: "success",
        };
      } else {
        return {
          filename: item.name,
          size: item.size,
          type: item.type,
          status: false,
          message: this.$t("fileErrorMsg", { filename: item.name }),
        };
      }
    },
  },
};

function onUpdateChunkUpload(params) {
  const index = this.chunkUploadFilesList.findIndex(item => item.fileName === params.fileName);

  if (params.isChunkUpload) {
    if (index === -1) {
      this.chunkUploadFilesList.push(params);
    }
  } else {
    if (index !== -1) {
      this.chunkUploadFilesList.splice(index, 1);
    }
  }
}

function openUploadDialog() {
  this.isChunkUpload = false;
  this.uploadDialog = true
}

function signalRInit(target) {
  this.signalConnection.on(target, async (response) => {
    let data;
    if (isObject(response)) {
      data = response;
    } else {
      data = JSON.parse(response);
    }

    if (data.action && (data.action === "create" || data.action === "rename")) {
      if (this.$security.checkUserAccess("ViewDirectory")) {
        this.loadingDirectories = true;
        await this.getDirectoryListApi();
        this.loadingDirectories = false;
      }
    } else if (data.action && data.action === "delete") {
      if (data.parentId) {
        let parent = this.treeItems.find((f) => f.id === data.parentId);
        if (parent) {
          await this.selectItem(parent);
        } else {
          await this.setTreeViewFocusOnDeletion(data.id);
        }
      } else {
        await this.setTreeViewFocusOnDeletion(data.id);
      }
      await this.getDirectoryListApi();
    } else if (data.action && data.action === "deletedirectories") {
      this.loadingDirectories = true;
      await this.getDirectoryListApi();
      this.loadingDirectories = false;
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function signalRDocumentInit(target) {
  this.signalConnection.on(target, async (response) => {
    if (response.directoryid) {
      this.loadingDirectories = true;
      await this.getDirectoryListApi();
      this.loadingDirectories = false;
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function onDocumentUpload() {
  try {
    if (this.showFileReqMsg(this.uploadingFiles)) {
      this.isFileRequired = true;
      return;
    }
    if (this.$refs.form.validate()) {
      this.loadingUpload = true;

      this.isFileRequired = false;
      const maxSize = MAX_UPLOAD_SIZE ?? 0;

      const filesWithStatus = await this.uploadFiles(
        this.uploadingFiles,
        maxSize
      );


      this.selectedItems = await this.getSelectedItems(this.selectedNode);
      await this.selectItem(this.selectedNode);
      await this.showMessageSheet(
        this.$t("documents.DocUploadSuccessMessage"),
        "success"
      );
      this.resetForm();
      this.closeUploadFiles();

      if (filesWithStatus.length > 0) {
        this.dropFileSuccessDialog = true;
        this.documentdropFiles = filesWithStatus;
      }
      this.loadingUpload = false;
    }
  } catch (error) {
    this.loadingUpload = false;
  }
}
async function onDocumentUploadOld() {
  if (this.$refs.form.validate()) {
    const promises = [];
    let formData;
    this.uploadingFiles.forEach(async (item) => {
      formData = new FormData();
      formData.append("tenantId", this.selectedTenant);
      formData.append("topicId", "");
      formData.append("documentId", createUUID());
      formData.append("meetingId", "");
      formData.append("agendaId", "");
      formData.append("directoryId", this.selectedNode.id);
      formData.append("peopleId", "");
      formData.append("attachment", item);
      promises.push(this.createDocuments(formData));
    });
    await Promise.all(promises);

    this.$refs.form.reset();
    this.$refs.form.resetValidation();

    this.selectedItems = await this.getSelectedItems(this.selectedNode);
    await this.selectItem(this.selectedNode);
    this.showMessageSheet(
      this.$t("documents.DocUploadSuccessMessage"),
      "success"
    );
    this.closeUploadFiles();
  }
}

async function uploadDropedFiles(data) {
  let files = Array.from(data);
  this.uploadingFiles = files;
  this.isChunkUpload = false;
  this.uploadDialog = true;
}

async function uploadDropedFilesOrigin(data) {
  if (data.uploadable.length > 0) {
    const promises = [];
    let formData;
    data.uploadable.forEach(async (item) => {
      formData = new FormData();
      formData.append("tenantId", this.selectedTenant);
      formData.append("topicId", "");
      formData.append("documentId", createUUID());
      formData.append("meetingId", "");
      formData.append("agendaId", "");
      formData.append("directoryId", this.selectedNode.id);
      formData.append("peopleId", "");
      formData.append("attachment", item);
      promises.push(this.createDocuments(formData));
    });

    await Promise.all(promises);
    this.documentdropFiles = data;
    this.selectedItems = await this.getSelectedItems(this.selectedNode);
    await this.selectItem(this.selectedNode);
  }
  if (data.filestatus.length > 0) {
    this.dropFileSuccessDialog = true;
    this.documentdropFiles = data.filestatus;
  }
}

function addUploadingFiles(files) {
  files = Array.from(files);
  this.uploadingFiles.push(...files);
}

function removeUploadingFile(index) {
  this.uploadingFiles.splice(index, 1);
}
